import Alpine from 'alpinejs';
import { CartService } from '../service/CartService';
import { Product } from '../types/types';

(window as typeof window & { Alpine: typeof Alpine }).Alpine = Alpine;

document.addEventListener('alpine:init', () => {
  const cartService = new CartService();

  Alpine.data('cartPage', () => ({
    cart: cartService.getCart(),
    total: cartService.getTotal(),

    updateQuantity(productId: string, quantity: number) {
      cartService.updateQuantity(productId, quantity);
      this.refreshCart();
    },

    removeFromCart(productId: string) {
      cartService.removeFromCart(productId);
      this.refreshCart();
    },

    refreshCart() {
      this.cart = cartService.getCart();
      this.total = cartService.getTotal();
    },

    checkout() {
      const url = this.buildCheckoutLink(this.cart)
      window.location.href = url
    },

    buildCheckoutLink(products: Pick<Product, 'hpr_product_id' | 'hpr_variation_id' | 'hpr_attribute_name' | 'hpr_attribute_value'>[]) {
      const baseUrl = 'https://horseprerace.com/checkout/?';
      const params = new URLSearchParams();

      products.forEach((product, index) => {
        // Add product ID to the query params
        params.append('add-to-cart', product.hpr_product_id);

        // Add variation ID if available
        if (product.hpr_variation_id) {
          params.append(`variation_id`, product.hpr_variation_id);
        }

        // Add attribute name and value if available
        if (product.hpr_attribute_name && product.hpr_attribute_value) {
          const attributeSlug = `${product.hpr_attribute_name.toLowerCase()}`;
          params.append(attributeSlug, product.hpr_attribute_value);
        }
      });

      return baseUrl + params.toString();
    },

    init() {
      this.refreshCart();
    }
  }));
});

Alpine.start();
